import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const LocationService = {

  getProvinces: () => {
    return axios.get(`/api/v1/location/getProvinces/`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  getDistrictsByProvince: (provinceCode) => {
    return axios.get(`/api/v1/location/getDistrictsByProvince/${provinceCode}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  getWardsByDistrict: (districtCode) => {
    return axios.get(`/api/v1/location/getWardsByDistrict/${districtCode}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
}